import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Box } from "@mui/material";
import Layout from "./components/Layout";
import Dashboard from "./pages/dashboard/Dashboard";
import TaskAssingment from "./pages/tasks-assigning/TaskAssingment";
import TasksApproval from "./pages/tasks-approval/TasksApproval";
import Retailers from "./pages/retailers/Retailers";
import Tasks from "./pages/tasks/Tasks";
import Login from "./pages/auth/Login";
import ProtectedRoute from "./utils/ProtectedRoutes";
import Taskreport from "./pages/reports/Taskreport";
import Taskss from "./pages/reports/Task/Taskss";
import ParentTask from "./pages/reports/Tasks/ParentTask"
import TabCards from "./pages/retask/TabCards";
import CreateTask from "./pages/create-task/CreateTask";
import Brands from "./pages/brands/Brands";
import AddBrand from "./pages/brands/AddBrand";
import AddBanner from "./pages/brands/AddBanner";
import AssignTask from "./pages/assign-task/AssignTask";
// import CohortCard from "./components/AssignTask/CohortCard";
import CohortUser from "./components/AssignTask/CohortUser";
import { AllTasksProvider } from "./components/store/AlltasksContext";
import AllVendor from "./components/AssignTask/AllVendor";
import ActivityLog from "./pages/ActivityLog/ActivityLog";
import Taskreports from "./pages/reports/Taskreport";
import Retailerreports from "./pages/reports/RetailersReports/Retailerreports";
import ReportTable from "./pages/reports/RetailersReports/ReportTable";
import TaskTable from "./pages/reports/RetailersReports/TaskTable";


import RewardsPointsBook from "./pages/reports/RewardsPointsBook/RewardsPointsBook";
import RewardsPointsBook2 from "./pages/reports/RewardsPointsBook/RewardsPointsBook";


import ApprovalDrawer from "./pages/tasks-approval/ApprovalDrawer";
import EditAddBrand from "../src/pages/brands/EditAddBrand";
import EditBanner from "./pages/brands/EditBanner";
import { AlertProvider } from "./pages/AlertContext/AlertContext";
import AlertComponent from "./pages/AlertContext/AlertComponent";
import Teammembers from "./pages/Teammembers/team-members";
import CohortCard from "./components/AssignTask/CohortCard";
import TeamForm from "./components/TeamMembers/TeamForm";
import Test from "./pages/assign-task/Previewtaskall";
import EditTeamForm from "./components/TeamMembers/EditTeamForm";
import Previewtaskall from "./pages/assign-task/Previewtaskall";
import ModuleOwnerForm from "./components/TeamMembers/ModuleOwnerForm";
import OwnerTable from "./components/TeamMembers/OwnerTable";
import ProfileSetting from "./components/ProfileSetting/ProfileSetting";
import ForgotPassword from "./pages/auth/ForgotPassword";
import ResetLink from "./pages/auth/ResetLink";
import ResetPassword from "./pages/auth/ResetPassword";
// import LoginOtpRep from "./pages/reports/LoginOtp/ReportsLogTable";
import ReportsMasterTable from "./pages/reports/MasterOutlist/ReportsMasterTable";
import PasswordChanged from "./pages/auth/FinalForgotPassword";
import ChangePassword from "./pages/auth/ChangePassword";
import ActiveAssignTask from "./components/ActiveTask/ActiveAssignTask";
import PasswordReset from "./pages/auth/PasswordRest";
import RewardsCont from "./pages/reports/RetailerAll/ReportsCont";
import ReportsAccount from "./pages/reports/RetailerAccount/ReportsAccount";
import ReportsOutlet from "./pages/reports/RetailerOutlet/ReportsOutlet";
import BulkUploads from "./pages/reports/bulkupload/Bulkuploads";
import ReportsLogin from "./pages/reports/LoginOtp/ReportsLogin";
import ReportMaster from "./pages/reports/MasterOutlist/ReportMaster";
import ReportIr from "./pages/reports/IrAnalysis/ReportIr";






// import TaskApprovalDetails from "./pages/tasks-approval/TaskApprovalDetails";
const currentLang = "en";

const App: React.FC = () => {
  return (
    <AlertProvider>
      {/* <AlertComponent /> */}
      <AllTasksProvider currentLang={currentLang}>

        <Router>
          <Routes>
            <Route path="/login" index element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-link" element={<ResetLink />} />
            <Route path="/resetpassword" element={<ResetPassword />} />
            <Route path="/password-changed" element={<PasswordChanged />} />
            <Route path="/change-password" element={<ChangePassword />} />
            <Route path="/reset-password" element={<PasswordReset />} />

            {/* <Route path="/" element={<ApprovalDrawer SideDrawer={[]} rows={{id: ""}} datayaya={undefined} value112={undefined} finaldata22={undefined} selectedLocation={undefined} SelectedTaskId={undefined} debouncedSearchTerm={undefined} pageindex={undefined} limit={undefined} />} />
          <Route path="/approve-message" element={<TasksApproval filterdatawww={undefined}  />} /> */}
            <Route
              path="/"
              element={
                <Layout>
                  <ProtectedRoute allowedRoles={["Admin", "Team Member", "Module Owner"]}>
                    <Dashboard />
                  </ProtectedRoute>
                </Layout>
              }
            />
            <Route
              path="/team-Members"
              element={
                <Layout>
                  <ProtectedRoute allowedRoles={["Admin", "Team Member", "Module Owner"]}>
                    <Teammembers />
                  </ProtectedRoute>
                </Layout>
              }
            />
            <Route
              // path="/active-task/assign-task/:maintaskid"
               path="/active-task/assign-task/:maintaskid/:taskType"
              element={
                <Layout>
                  <ProtectedRoute allowedRoles={["Admin", "Team Member", "Module Owner"]}>
                    <ActiveAssignTask />
                  </ProtectedRoute>
                </Layout>
              }
            />
            <Route
              path="/team-Members/team-form"
              element={
                <Layout>
                  <ProtectedRoute allowedRoles={["Admin", "Team Member", "Module Owner"]}>
                    <TeamForm />
                  </ProtectedRoute>
                </Layout>
              }
            />
            <Route
              path="/team-Members/team-form/:copyid"
              element={
                <Layout>
                  <ProtectedRoute allowedRoles={["Admin", "Team Member", "Module Owner"]}>
                    <TeamForm />
                  </ProtectedRoute>
                </Layout>
              }
            />
            <Route
              path="/team-Members/module-owner-form"
              element={
                <Layout>
                  <ProtectedRoute allowedRoles={["Admin", "Team Member", "Module Owner"]}>
                    <ModuleOwnerForm />
                  </ProtectedRoute>
                </Layout>
              }
            />
            <Route
              path="/team-Members/module-owner-form/:mainmoduleid"
              element={
                <Layout>
                  <ProtectedRoute allowedRoles={["Admin", "Team Member", "Module Owner"]}>
                    <ModuleOwnerForm />
                  </ProtectedRoute>
                </Layout>
              }
            />
            <Route
              path="owner-table"
              element={
                <Layout>
                  <ProtectedRoute allowedRoles={["Admin", "Team Member", "Module Owner"]}>
                    <OwnerTable />
                  </ProtectedRoute>
                </Layout>
              }
            />

            <Route
              path="/team-Members/team-form/id:id"
              element={
                <Layout>
                  <ProtectedRoute allowedRoles={["Admin", "Team Member", "Module Owner"]}>
                    <TeamForm />
                  </ProtectedRoute>
                </Layout>
              }
            />
            <Route
              path="/team-Members/edit-team-form/:id"
              element={
                <Layout>
                  <ProtectedRoute allowedRoles={["Admin", "Team Member", "Module Owner"]}>
                    <EditTeamForm />
                  </ProtectedRoute>
                </Layout>
              }
            />

            <Route
              path="/team-Members/edit-team-form/:memeberid?source=messenger/status"
              element={
                <Layout>
                  <ProtectedRoute allowedRoles={["Admin", "Team Member", "Module Owner"]}>
                    <EditTeamForm />
                  </ProtectedRoute>
                </Layout>
              }
            />


            <Route
              path="/tasks"
              element={
                <Layout>
                  <ProtectedRoute allowedRoles={["Admin", "Team Member", "Module Owner"]}>
                    <Tasks />
                  </ProtectedRoute>
                </Layout>
              }
            />
            <Route
              path="/edit-brand/:id"
              element={
                <Layout>
                  <ProtectedRoute allowedRoles={["Admin", "Team Member", "Module Owner"]}>
                    <EditAddBrand />
                  </ProtectedRoute>
                </Layout>
              }
            />
            <Route
              path="/edit-banner/:bannerId"
              element={
                <Layout>
                  <ProtectedRoute allowedRoles={["Admin", "Team Member", "Module Owner"]}>
                    <AddBanner />
                  </ProtectedRoute>
                </Layout>
              }
            />
            {/* <Route
            path="/retailers"
            element={
              <Layout>
                <ProtectedRoute allowedRoles={["admin"]}>
                  <Retailers />
                </ProtectedRoute>
              </Layout>
            }
          /> */}
            <Route
              path="/retailers/retailerslist"
              element={
                <Layout>
                  <ProtectedRoute allowedRoles={["Admin", "Team Member", "Module Owner"]}>
                    <Retailers />
                  </ProtectedRoute>
                </Layout>
              }
            />
            <Route
              path="/retailers/leaderboard"
              element={
                <Layout>
                  <ProtectedRoute allowedRoles={["Admin", "Team Member", "Module Owner"]}>
                    <Retailers />
                  </ProtectedRoute>
                </Layout>
              }
            />
            <Route
              path="/tasks-approval"
              element={
                <Layout>
                  <ProtectedRoute allowedRoles={["Admin", "Team Member", "Module Owner"]}>
                    <TasksApproval />
                  </ProtectedRoute>
                </Layout>
              }
            />
            {/* <Route
          path="/tasks-approval/:id"
          index
          element={
            <Layout>
              <TaskApprovalDetails />
            </Layout>
          }
        /> */}
            <Route
              path="/tasks-assignent"
              element={
                <Layout>
                  <ProtectedRoute allowedRoles={["Admin", "Team Member", "Module Owner"]}>
                    <TaskAssingment />
                  </ProtectedRoute>
                </Layout>
              }
            />
            {/* <Route
            path="/reports"
            element={
              <Layout>
                <ProtectedRoute allowedRoles={["admin"]}>
                  <Taskreport />
                </ProtectedRoute>
              </Layout>
            }
          /> */}
            <Route
              path="/reports/taskreports"
              element={
                <Layout>
                  <ProtectedRoute allowedRoles={["Admin", "Team Member", "Module Owner"]}>
                    <Taskreports />
                  </ProtectedRoute>
                </Layout>
              }
            />
            <Route
              path="/reports/tasks"
              element={
                <Layout>
                  <ProtectedRoute allowedRoles={["Admin", "Team Member", "Module Owner"]}>
                    <Taskss />
                  </ProtectedRoute>
                </Layout>
              }
            />
            <Route
              path="/reports/retailersreports"
              element={
                <Layout>
                  <ProtectedRoute allowedRoles={["Admin", "Team Member", "Module Owner"]}>
                    <Retailerreports />
                  </ProtectedRoute>
                </Layout>
              }
            />
            <Route
              path="/reports/reportstable"
              element={
                <Layout>
                  <ProtectedRoute allowedRoles={["Admin", "Team Member", "Module Owner"]}>
                    <ReportTable />
                  </ProtectedRoute>
                </Layout>
              }
            />


            <Route
              path="/reports/tasks"
              element={
                <Layout>
                  <ProtectedRoute allowedRoles={["Admin", "Team Member", "Module Owner"]}>
                    <TaskTable />
                  </ProtectedRoute>
                </Layout>
              }
            />



            <Route
              path="/reports/rewards-pointsreports"
              element={
                <Layout>
                  <ProtectedRoute allowedRoles={["Admin", "Team Member", "Module Owner"]}>
                    <RewardsPointsBook />
                  </ProtectedRoute>
                </Layout>
              }
            />

            <Route
              path="/reports/rewards-pointsreports"
              element={
                <Layout>
                  <ProtectedRoute allowedRoles={["Admin", "Team Member", "Module Owner"]}>
                    <Taskreport />
                  </ProtectedRoute>
                </Layout>
              }
            />
            <Route
              path="/manage-task"
              element={
                <Layout>
                  <ProtectedRoute allowedRoles={["Admin", "Team Member", "Module Owner"]}>
                    <TabCards />
                  </ProtectedRoute>
                </Layout>
              }
            />
            <Route
              path="/manage-task/:task_id/:end_date"
              element={
                <Layout>
                  <ProtectedRoute allowedRoles={["Admin", "Team Member", "Module Owner"]}>
                    <TabCards />
                  </ProtectedRoute>
                </Layout>
              }
            />
            <Route
              path="/manage-task/create-task"
              element={
                <Layout>
                  <ProtectedRoute allowedRoles={["Admin", "Team Member", "Module Owner"]}>
                    <CreateTask />
                  </ProtectedRoute>
                </Layout>
              }
            />


            <Route
              path="/manage-task/edit-task/:id"
              element={
                <Layout>
                  <ProtectedRoute allowedRoles={["Admin", "Team Member", "Module Owner"]}>
                    <CreateTask />
                  </ProtectedRoute>
                </Layout>
              }
            />


            <Route
              path="/brands"
              element={
                <Layout>
                  <ProtectedRoute allowedRoles={["Admin", "Team Member", "Module Owner"]}>
                    <Brands />
                  </ProtectedRoute>
                </Layout>
              }
            />
            <Route
              path="/add-brand"
              element={
                <Layout>
                  <ProtectedRoute allowedRoles={["Admin", "Team Member", "Module Owner"]}>
                    <AddBrand />
                  </ProtectedRoute>
                </Layout>
              }
            />
            <Route
              path="/add-banner"
              element={
                <Layout>
                  <ProtectedRoute allowedRoles={["Admin", "Team Member", "Module Owner"]}>
                    <AddBanner />
                  </ProtectedRoute>
                </Layout>
              }
            />
            <Route
              path="/assign-task/:id"
              element={
                <Layout>
                  <ProtectedRoute allowedRoles={["Admin", "Team Member", "Module Owner"]}>
                    <AssignTask branddetailslength1={0} />
                  </ProtectedRoute>
                </Layout>
              }
            />
            <Route
              path="/cohorts-view"
              element={
                <Layout>
                  <ProtectedRoute allowedRoles={["Admin", "Team Member", "Module Owner"]}>
                    <AssignTask branddetailslength1={0} />
                  </ProtectedRoute>
                </Layout>
              }
            />
            <Route
              path="/Admin_approval/:task_id/:task_type"
              element={
                <Layout>
                  <ProtectedRoute allowedRoles={["Admin", "Team Member", "Module Owner"]}>
                    <Previewtaskall />
                  </ProtectedRoute>
                </Layout>
              }
            />
            <Route
              path="/assign-task-cohort"
              element={
                <Layout>
                  <ProtectedRoute allowedRoles={["Admin", "Team Member", "Module Owner"]}>
                    <CohortCard />
                  </ProtectedRoute>
                </Layout>
              }
            />
            <Route
              path="/cohort-user/:cohort_id"
              element={
                <Layout>
                  <ProtectedRoute allowedRoles={["Admin", "Team Member", "Module Owner"]}>
                    <CohortUser />
                  </ProtectedRoute>
                </Layout>
              }
            />

            <Route
              path="/all-vendors"
              element={
                <Layout>
                  <ProtectedRoute allowedRoles={["Admin", "Team Member", "Module Owner"]}>
                    <AllVendor />
                  </ProtectedRoute>
                </Layout>
              }
            />
            <Route
              path="/activity-log"
              element={
                <Layout>
                  <ProtectedRoute allowedRoles={["Admin", "Team Member", "Module Owner"]}>
                    <ActivityLog />
                  </ProtectedRoute>
                </Layout>
              }
            />
            <Route
              path="/ProfileSetting"
              element={
                <Layout>
                  <ProtectedRoute allowedRoles={["Admin", "Team Member", "Module Owner"]}>
                    <ProfileSetting />
                  </ProtectedRoute>
                </Layout>
              }
            />

            <Route
              path="/reports/reports-account"
              element={
                <Layout>
                  <ProtectedRoute allowedRoles={["Admin", "Team Member", "Module Owner"]}>
                    <ReportsAccount />
                  </ProtectedRoute>
                </Layout>
              }
            />
            <Route
              path="/reports/outlet-reports"
              element={
                <Layout>
                  <ProtectedRoute allowedRoles={["Admin", "Team Member", "Module Owner"]}>
                    <ReportsOutlet />
                  </ProtectedRoute>
                </Layout>
              }
            />
            <Route
              path="/reportcontent"
              element={
                <Layout>
                  <ProtectedRoute allowedRoles={["Admin", "Team Member", "Module Owner"]}>
                    <RewardsCont />
                  </ProtectedRoute>
                </Layout>
              }
            />
            <Route
              path="/reports/bulkupload"
              element={
                <Layout>
                  <ProtectedRoute allowedRoles={["Admin", "Team Member", "Module Owner"]}>
                    <BulkUploads />
                  </ProtectedRoute>
                </Layout>
              }
            />
            <Route
              path="/reports/login-otp-report"
              element={
                <Layout>
                  <ProtectedRoute allowedRoles={["Admin", "Team Member", "Module Owner"]}>
                    <ReportsLogin />
                  </ProtectedRoute>
                </Layout>
              }
            />

            <Route
              path="/reports/master-report"
              element={
                <Layout>
                  <ProtectedRoute allowedRoles={["Admin", "Team Member", "Module Owner"]}>
                    <ReportMaster />
                  </ProtectedRoute>
                </Layout>
              }
            />
<Route
              path="/manage-task/duplicate-task/:duplicate_id"
              element={
                <Layout>
                  <ProtectedRoute allowedRoles={["Admin", "Team Member", "Module Owner"]}>
                    <CreateTask />
                  </ProtectedRoute>
                </Layout>
              }
            />

            <Route
              path="/reports/basic-account-report"
              element={
                <Layout>
                  <ProtectedRoute allowedRoles={["Admin", "Team Member", "Module Owner"]}>
                    <ReportIr />
                  </ProtectedRoute>
                </Layout>
              }
            />
            <Route
              path="/reports/export-task_reprort"
              element={
                <Layout>
                  <ProtectedRoute allowedRoles={["Admin", "Team Member", "Module Owner"]}>
                    <ParentTask />
                  </ProtectedRoute>
                </Layout>
              }
            />
          </Routes>
        </Router>
      </AllTasksProvider>
    </AlertProvider>
  );
};

export default App;
<Route
  path="/cohort-user/:cohort_id"
  element={
    <Layout>
      <ProtectedRoute allowedRoles={["Admin", "Team Member", "Module Owner"]}>
        <CohortUser />
      </ProtectedRoute>
    </Layout>
  }

/>;
